const Wrapper = ({ children, className = 'p-3' }) => {
    return (
        <div className={`flex items-center justify-center w-full aspect-square bg-white border border-gray-200 rounded-lg ${className}`}>
            {children}
        </div>
    )
}

// Icons
import { IconPhotoOff } from '@tabler/icons-react'

export default function ImageWithFallbacks({ images, width = 100, className }) {
    // Return first existing image
    const image = images.find((image) => image)

    if (image) {
        const isShopifyImage = image.includes('cdn.shopify.com')
        const isRelativeImage = !image.includes('http')

        if (isShopifyImage) {
            const src = image + '&width=' + width

            return (
                <Wrapper className={className}>
                    <img className="w-full h-full object-contain" src={src} />
                </Wrapper>
            )
        }

        if (isRelativeImage) {
            const src =
                'https://wtlltffvwmgvkdwvakua.supabase.co/storage/v1/object/public/products/' +
                image
            return (
                <Wrapper className={className}>
                    <img className="w-full h-full object-contain" src={src} />
                </Wrapper>
            )
        }
    }

    // Return fallback if no image

    return (
        <Wrapper className={className}>
            <IconPhotoOff className="text-gray-400" />
        </Wrapper>
    )
}
